import { InputMaybe, OrderOption } from '../../apis/graphql/types';
import { SortBy } from '../../hooks/useBaseTableFilters/types';

export type SortOptions<T = string> = {
  sortBy?: InputMaybe<T>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const prepareSortOptions = <T = string>(
  sortBy: SortBy<T>[],
  defaultSortingField?: InputMaybe<T>
): InputMaybe<SortOptions<T>> => {
  if (sortBy.length) {
    return {
      sortBy: sortBy[0].id,
      sortOrder: sortBy[0].desc ? OrderOption.Desc : OrderOption.Asc,
    };
  }

  if (defaultSortingField) {
    return {
      sortBy: defaultSortingField,
      sortOrder: OrderOption.Desc,
    };
  }

  return null;
};
